module.exports = __webpack_public_path__ + "faq/img/login3.c767aac8.png";